// extracted by mini-css-extract-plugin
export default {"unsubsribe":"styles_unsubsribe__lrSji","message":"styles_message__VVOGW"};